export const actionTypes = {
  FIREBASE_INITAILIZE: "[FIREBASE] INITIALIZE STATUS",
};

export const INITIAL_STATE = {
  initialized: false,
};

export const reducer = (state = INITIAL_STATE, action) => {
  const { type, payload } = action;

  switch (type) {
    case actionTypes.FIREBASE_INITAILIZE:
      return { ...state, initialized: true };

    default:
      return state;
  }
};

export const actions = {
  update_firebase_status: () => ({
    type: actionTypes.FIREBASE_INITAILIZE,
    payload: true,
  }),
};

//   export default reducer;
